import ApiConnector from "../connector";
import ApiConnectorFormData from "../connectorFormData";

class AttachmentsActions {
  create = async (file) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnectorFormData.connector.post(`/attachments/`, file);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  delete = async (id) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.delete(`/attachments/${id}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
}

export default new AttachmentsActions();
